import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {Request, RequestsMixin, GET} from 'requests';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {default as Spinner, SIZE_BASE} from 'components/Spinner';
import ResourcesMatching from 'requests/components/ResourcesMatching';
import Requesting from 'requests/components/Requesting';
import Done from 'requests/components/Done';
import WoffEmbeddedIcon from 'components/WoffEmbeddedIcon';

const mapStateToProps = (state, props) => {
  const {kitToken} = props;

  return {
    kitToken,
    requests: state.requests,
  };
};

const KitLogo = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    kitToken: PropTypes.string.isRequired,
  },

  mixins: [RequestsMixin, ImmutableRenderMixin],

  componentWillMount() {
    this.setRequest({
      workingSetIcons: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons'],
      }),
    });
  },

  resources() {
    const rm = this.resourceManager();

    return {
      workingSetIcons: rm.type(this.requests.workingSetIcons, 'working-set-icons').all(),
      icons: rm.type(this.requests.workingSetIcons, 'icons').all(),
    };
  },

  renderSpinner() {
    return (
      <span className="kit-logo-blank">
        <span className="kit-logo-inner text-xs-center">
          <span className="kit-logo-rendering">
            <span className="blank-focus is-loading">
              <Spinner size={SIZE_BASE} />
            </span>
          </span>
        </span>
      </span>
    );
  },

  renderBlank() {
    const {kitToken} = this.props;

    return (
      <Link to={`/kits/${kitToken}/logo/upload`} className="kit-logo-blank">
        <span className="kit-logo-inner text-xs-center">
          <span className="kit-logo-rendering">
            <span className="blank-focus">
              <i className="ficon ficon-plus-circle"></i><br />Logo
            </span>
          </span>
        </span>
      </Link>
    );
  },

  renderLogo(workingSetIcon) {
    const {kitToken} = this.props;

    return (
      <Link to={`/kits/${kitToken}/icons/${workingSetIcon.id}`} className="kit-logo">
        <span className="kit-logo-inner text-xs-center">
          <span className="kit-logo-rendering">
            <span className="logo-default">
              <WoffEmbeddedIcon woff={workingSetIcon.woff} />
            </span>
            <span className="logo-focus">
              <i className="ficon ficon-pencil"></i><br />Logo
            </span>
          </span>
        </span>
      </Link>
    );
  },

  renderMain() {
    const {workingSetIcons} = this.resources();
    const kitLogo = workingSetIcons.filter(record => record.logo).first();

    return (kitLogo) ? this.renderLogo(kitLogo) : this.renderBlank();
  },

  render() {
    return (
      <ResourcesMatching manager={this.resourceManager()}>
        <Requesting any={true} render={this.renderSpinner} />
        <Done all={true} render={this.renderMain} />
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(KitLogo);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/KitLogo.js